import { cva } from 'class-variance-authority'

/**
 * Focus Mode dimming (GitHub issue #20).
 *
 * Applied to non-essential chrome — top navigation, dashboard widgets other
 * than the active Deep Work tile — while a Deep Work session is running.
 * Dimmed elements reveal at full opacity on hover/focus so they stay
 * reachable without breaking the session's intent, then fade back out.
 *
 * The opacity transition is skipped for users with
 * `prefers-reduced-motion: reduce` set (Tailwind's `motion-reduce:` variant).
 */
export const focusDim = cva(
  'transition-opacity duration-700 ease-out motion-reduce:transition-none motion-reduce:duration-0',
  {
    variants: {
      dimmed: {
        true: 'opacity-25 hover:opacity-100 focus-within:opacity-100',
        false: 'opacity-100',
      },
    },
    defaultVariants: {
      dimmed: false,
    },
  }
)
